import FormattedMessage from 'I18n/components/FormattedMessage';
import { H4 } from 'foundations-components/transitional/components/H4';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ApprovalDataErrorMessage() {
  return /*#__PURE__*/_jsx(ErrorMessage, {
    "data-test-id": "approval-data-error-message",
    title: /*#__PURE__*/_jsx(H4, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalDataError.title"
      })
    }),
    children: /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalDataError.content"
      })
    })
  });
}